import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action, createAction } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ContentService } from '@amfam/shared/utility/shared-services';

import {
  loadComponentConfig,
  loadComponentConfigFailure,
  loadComponentConfigSuccess
} from './component-config.actions';

@Injectable()
export class ComponentConfigEffects implements OnInitEffects {
  configLoaded = false;

  loadConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadComponentConfig),
      mergeMap(() =>
        this.contentService.getContent('sharedcomponentpartnermapping').pipe(
          map(config => JSON.parse(config?.richContent || '')),
          map(config => loadComponentConfigSuccess({ config })),
          catchError(error => of(loadComponentConfigFailure({ error })))
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private contentService: ContentService
  ) {}

  ngrxOnInitEffects(): Action {
    if (!this.configLoaded) {
      this.configLoaded = true;
      console.log('component loading !');
      return loadComponentConfig();
    }
    return createAction('Empty Action');
  }
}
